export const formatnameList = (nameListInString: string) => {
  return nameListInString?.split("\n") || [];
};
